import { callFxgApi } from 'axp-fx-common';
import { apiPaths } from '../constants/paths';

// this functions returns the list from the api. To be used only if api return list but not object
// in case of api errors, will return empty list
export const fetchListDataFromGetAPI = async (path) => {
  const { response, hasErrors } = await callFxgApi(path, 'GET', null);

  if (!hasErrors) {
    return response || [];
  }
  return [];
};

// fetches all the action types
export const fetchActionTypes = async (apiMetaData) => {
  const { fxgApiHost } = apiMetaData;
  const data = await fetchListDataFromGetAPI(
    `${fxgApiHost}${apiPaths.getActionTypes}`
  );
  return data;
};

// fetches all the status
export const fetchStatuses = async (apiMetaData) => {
  const { fxgApiHost } = apiMetaData;
  const data = await fetchListDataFromGetAPI(
    `${fxgApiHost}${apiPaths.getStatus}`
  );
  return data;
};

export const fetchDialCodes = async (apiMetaData) => {
  const { fxgApiHost } = apiMetaData;
  const data = await fetchListDataFromGetAPI(
    `${fxgApiHost}${apiPaths.getDialCodes}`
  );
  return data;
};
